import { SxProps, Theme } from '@mui/system';

const styles = {
  container: {
    p: '16px',
    backgroundColor: 'pharmacist.requestedLight',
    my: '16px',
    borderRadius: '16px',
    borderTopLeftRadius: 0,
  },
  note: {
    fontSize: 12,
    color: 'common.grey850',
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
